import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom"
import { useNavigate } from "react-router-dom";
import { useServerConnection } from "../hooks/ServerConnection"
import MachinesList from "./MachinesList";
import { useGitlabAccessToken } from "../hooks/GitlabAccessToken";
import { VMConfig } from "common/types/VMConfig";
import { Select } from "semantic-ui-react";


const ConfirmVMCreation = () => {
    const [accessToken] = useGitlabAccessToken()
    const serverConnection = useServerConnection()
    const [seachParams] = useSearchParams()
    const navigate = useNavigate()
    const namespace = seachParams.get('namespace');
    const project = seachParams.get('project');
    const ref = seachParams.get('ref');

    const [config, setConfig] = useState<{
        type: "loading"
    } | {
        type: "error",
        error: string,
    } | {
        type: "config not exists"
    } | {
        type: "config",
        config: VMConfig
    }>({
        type: "loading"
    })
    
    useEffect(() => {
        document.title = `VM — ${project}`
    }, [project])

    useEffect(() => {
        async function loadVMConfig() {
            const config = await serverConnection.projectVMConfig(accessToken, {
                namespace, project, ref
            })
            setConfig(config)
        }
        loadVMConfig()
    }, [namespace, project, ref])

    // const [configProperty, setConfigProperty] = useState("config")
    const [alternativeConfigIndex, setAlternativeConfigIndex] = useState(-1)
    // const [alternativeConfigName, setAlternativeConfigName] = useState<string>(undefined)

    if (config.type === "error" && config.error === "invalid_token") {
        navigate(`/request-access-code?project=${project}&namespace=${namespace}${ref ? `&ref=${ref}` : ''}`)
    }

    if(config.type === "error") {
        return (
            <div>
                {config.error}
            </div>
        )
    }

    if(config.type === "config not exists") {
        return (
            <span>Please create VM config files</span>
        )
    }

    if(config.type === "loading") {
        return <div/>
    }

    if(config.type === "config") {
        return (
            <section className="h-full">
                <MachinesList
                    repo={{
                        namespace,
                        project,
                    }}
                    createVMComponent={
                        (config.config.alternativeConfigs && config.config.alternativeConfigs.length > 0)
                            ? (
                                <div style={{
                                    display: "flex",
                                    gap: 20,
                                }}>
                                    <Select
                                        options={[
                                            {
                                                text: config.config.defaultConfigName || "Default",
                                                value: -1,
                                            },
                                            ...config.config.alternativeConfigs.map((alternativeOption, index) => {
                                                return {
                                                    text: alternativeOption.name,
                                                    value: index,
                                                }
                                            })
                                        ]}
                                        value={alternativeConfigIndex}
                                        onChange={(e, { value }) => {
                                            setAlternativeConfigIndex(value as number)
                                        }}
                                    />
                                    <button
                                        className="btn btn-outline btn-neutral"
                                        onClick={() => {
                                            serverConnection.buildAndStartProjectVM(accessToken, { namespace, project, ref }, {
                                                alternativeConfigIndex,
                                            })
                                        }}
                                    >
                                        Create New VM
                                    </button>
                                </div>
                            )
                            : (
                                <button
                                    className="btn btn-outline btn-neutral"
                                    onClick={() => serverConnection.buildAndStartProjectVM(accessToken, { namespace, project, ref }, {
                                        alternativeConfigIndex: -1
                                    })}
                                >
                                    Create New VM
                                </button>
                            )
                    }
                />
            </section>
        )
    }

    return (
        <div>
            Unsupported config type {config['type']}
        </div>
    )
}

export default ConfirmVMCreation